import React, { Component } from 'react';
import classNames from 'classnames';

import styles from './ContactUsPage.module.scss';

import Notification from '@/components/Base/Notification';
import ContactUs from '@/components/Profile/ContactUs';

class Index extends Component {
  render() {
    return (
      <div className="font-size-default">
        <div className={classNames('container', styles.contactUsPage)}>
          <ContactUs login />;
          <Notification />
        </div>
      </div>
    );
  }
}

export default Index;
